# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

import { isHeicFile } from './file_utils'

jQuery ->

  $('.image-container a[data-remote="true"]').bind 'ajax:before', ->
    $(@).parent().find('img').css 'opacity', 0.5

  $('.image-container a[data-remote="true"]').bind 'ajax:complete', ->
    $(@).parent().find('img').css 'opacity', 1

  (->
    form            = $ '#new_note'
    progressElement = form.find '.progress'
    barElement      = progressElement.find '.bar'
    preview         = $ '.note-image-preview-container'
    image           = $ '<img/>'
    dataObject      = null

    preview.hide()

    readImage       = (input) ->
      file = input.files[0]
      if isHeicFile(file)
        $('.image-note-uploader').addClass 'w-75'
        $('.note-image-preview-container').addClass 'w-25'
        preview.show()
        preview.html """
          <div class="heic-preview">
            <i class="fa fa-image fa-3x"></i>
            <p><strong>#{file.name}</strong></p>
            <small>HEIC forhåndsvisning ikke tilgængelig.<br>Billedet vises efter upload.</small>
          </div>
        """
        return

      if window.FileReader

        $('.image-note-uploader').addClass 'w-75'
        $('.note-image-preview-container').addClass 'w-25'
        preview.show()

        preview.append image

        reader = new FileReader()

        reader.onload = (evt) =>
          image.attr 'src', evt.target.result
          preview.show()
          image.show()
          image.addClass("img-fluid")
          image.addClass("pr-3")

        reader.readAsDataURL input.files[0]

    form.bind 'ajax:complete', ->
      form[0].reset()
      image.remove()
      preview.hide()
      $('.image-note-uploader').removeClass 'w-75'
      $('.note-image-preview-container').removeClass 'w-25'

    form.find('input[type=file]').bind "change", (event) ->
      readImage event.target

  )()
